import request from '@/assets/util/request'   //ajax请求

export const districtList = (data)=> {
    return request({
        url: '/agent/api/district/list',
        method: 'post',
        data: data
    })
}


export const register = (data)=> {
    return request({
        url: '/register',
        method: 'post',
        data: data
    })
}
